<template>
  <div id="google-map">
    <div ref="map"></div>
  </div>
</template>

<script>
/* eslint-disable */
let _google = null
let _MarkerClusterer = null
setTimeout(() => {
  _google = google
  _MarkerClusterer = MarkerClusterer
}, 3000)
/* eslint-enable */

export default {
  props: {
    countryName: {
      type: String,
      default: () => ''
    },
    mapOption: {
      type: Object,
      default: () => null
    },
    mapEvents: {
      type: Array,
      default: () => [
        'center_changed'
      ]
    },
    markerOptions: {
      type: Array,
      default: () => null
    },
    markerEvents: {
      type: Array,
      default: () => [
        'click'
      ]
    }
  },
  data () {
    return {
      country: null,
      mapObj: {
        geocoder: null,
        map: null,
        markers: null,
        clusterer: null
      }
    }
  },
  mounted () {
    this.getCountry()
  },
  watch: {
    'mapOption' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.init()
      }
    },
    'markerOptions' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.init()
      }
    },
    'mapEvents' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.setEventListener()
      }
    },
    'markerEvents' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.setEventListener()
      }
    }
  },
  methods: {
    getCountry () {
      this.mapObj.geocoder = new _google.maps.Geocoder()
      this.mapObj.geocoder.geocode({ address: this.countryName }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.country = results[0]
          }
        }
        this.init()
      })
    },
    init () {
      if (this.initMap()) {
        this.setEventListener()
      }
    },
    initMap () {
      try {
        let center = this.country ? { lat: this.country.geometry.location.lat(), lng: this.country.geometry.location.lng() } : null
        this.mapObj.map = new _google.maps.Map(this.$refs['map'], {
          zoom: 8,
          center: center || (this.markerOptions[0] ? this.markerOptions[0].position : { lat: 0, lng: 0 }),
          ...(this.mapOption || {})
        })
        this.mapObj.markers = this.markerOptions.map(markerOption => new _google.maps.Marker({
          map: this.map,
          ...(markerOption || {})
        }))
        this.mapObj.clusterer = new _MarkerClusterer(this.mapObj.map, this.mapObj.markers, {
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
        })
        return true
      } catch (error) {
        return false
      }
    },
    setEventListener () {
      this.mapEvents.forEach(event => {
        this.mapObj.map.addListener(event, () => {
          this.$emit('mapEvent', event, this.mapObj.map)
        })
      })
      this.markerEvents.forEach(event => {
        this.mapObj.markers.forEach(marker => {
          marker.addListener(event, () => {
            this.$emit('markerEvent', event, marker, this.mapObj.map)
          })
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#google-map
  width: 100%
  height: 100%
  & > div
    width: 100%
    height: 100%
</style>



// WEBPACK FOOTER //
// src/components/tool/googleMap.vue